import FAQPage from '@/views/faq';
import * as React from 'react';
export default {
  FAQPage,
  React
};